<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count= 'count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>设备类型:</label>
            <lk-select v-model='query.typeId' class="item">
              <lk-option v-for="(item, index) in typeList" :key="index" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>设备编码:</label>
            <lk-input clearable v-model='query.assertsCode' class="item"></lk-input>
          </div>
          <div class="queryItem">
            <label>设备名称:</label>
            <lk-input clearable v-model='query.name' class="item"></lk-input>
          </div>
          <!--<div class="queryItem">-->
            <!--<label>设备状态:</label>-->
            <!--<lk-select v-model='query.status' class="item">-->
              <!--<lk-option v-for="(item, index) in status" :key="index" :value="index+1">{{item}}</lk-option>-->
            <!--</lk-select>-->
          <!--</div>-->
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-button @click="addNew" :type="buttonType" :ghost="!!selection.length" class="add-plan-botton" v-if="handlePermission('planConfigAdd')">生成养护/检定计划</lk-button>
        <lk-table
          ref="selection"
          border
          :columns='columns'
          :data='tableData'
          @on-selection-change="onSelectionChange"
          ></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import assets from '../../services/assets';
import utils from '../../libs/utils';
import system from '../../services/system';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'plan',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  data() {
    return {
      showAdd: false,
      showEdit: false,
      storeList: [],
      query: {
        storeIdList: [],
        typeId: '',
        status: '',
        name: '',
        assertsCode: '',
      },
      columns: [
        {
          type: 'selection',
          width: 56,
        },
        {
          title: '设备编码',
          key: 'assertsCode',
          minWidth: 116,
        },
        {
          title: '设备类型',
          key: 'assertsTypeName',
          minWidth: 116,
        },
        {
          title: '设备名称',
          key: 'assertsName',
          minWidth: 116,
        },
        {
          title: '养护人',
          key: 'createUserName',
          minWidth: 116,
        },
        {
          title: '型号',
          key: 'unitType',
          minWidth: 116,
        },
        {
          title: '放置位置',
          key: 'placement',
          minWidth: 116,
        },
        {
          title: '养护状态',
          key: 'statusStr',
          minWidth: 116,
        },
        {
          title: '使用状态',
          key: 'assertsStatusStr',
          minWidth: 116,
        },
        {
          title: '下次养护/检定时间',
          key: 'nextTime',
          minWidth: 160,
        },
      ],
      tableData: [],
      status: ['在用', '停用', '封存', '报废'],
      typeList: [],
      selection: [],
    };
  },
  computed: {
    buttonType() {
      if (this.selection.length > 0) {
        return 'primary';
      }

      return 'default';
    },
  },
  methods: {
    onSelectionChange(selection) {
      this.selection = selection;
    },
    clear() {
      this.query = {
        typeId: '',
        status: '',
        name: '',
        assertsCode: '',

      };
    },
    getTypeList() {
      assets.typeList().then((res) => {
        if (res.data.status === 200) {
          this.typeList = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      assets.assetsPlanList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            // item.nextTime = utils.formatTime(item.nextTime, 'YYYY/MM/DD HH:mm');
            item.nextTime = utils.exchangeTime(item.nextTime);
          });
          this.tableData = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // handlePage(page) {
    //   this.query.page = page;
    //   this.getData();
    // },
    // handlePageSize(size) {
    //   this.query.size = size;
    //   this.getData();
    // },
    addNew() {
      const selection = this.selection;
      const curingIds = [];
      const scrapCodes = [];
      let type = '';

      // todo 类型去重
      let typeAssignCount = 0;
      if (selection.length <= 0) {
        this.$Message.error('请选择记录.');
        return;
      }
      selection.forEach((item) => {
        if (item.category != type) {
          type = item.category;
          typeAssignCount++;
        }

        if (item.assertsStatus === 4) {
          scrapCodes.push(item.assertsCode);
        }

        curingIds.push(item.id);
      });
      const data = {
        curingIds, type,
      };
      if (typeAssignCount >= 2) {
        this.$Message.error('计量器具和药品养护设备不能一起生成养护/检定计划。');
        return;
      }

      if (scrapCodes.length > 0) {
        this.$Message.error(`设备${scrapCodes.join(',')}已经报废，无需养护/检定`);
        return;
      }
      assets.addPlan(data).then((res) => {
        this.selection = [];
        this.$refs.selection.selectAll(false);
        if (res.data.status === 200) {
          this.$Message.success(res.data.data);
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getStroeList() {
      system.getBelongStores().then((res) => {
        if (res.data.status === 200) {
          this.storeList = res.data.data;
        }
      });
    },
  },
  mounted() {
    console.log('走到这了');
    this.handleSearch(true);
  },
  created() {
    // this.getData();
    this.getTypeList();
    this.getStroeList();

    if (this.roleType !== 2) {
      this.columns.splice(1, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
  },
};
</script>
<style lang="less" scoped>
.plan-list{
  .query-item{
    display: flex;
    align-items: center;
    .query-label{
      margin-right: 10px;
    }
  }
  .search-btn{
    margin-right: 10px;
  }
  .query-params-wrap{
    padding-bottom: 20px;
  }
  .add-plan-botton{
    margin-bottom: 13px;
  }
}
</style>
